// Strings align with login.roles keys and access levels from the roles API (see UserPermissions).
const CAMPAIGN_MANAGE = 'CampaignManage'
const HAS_PERMISSION = 'HasPermission'
const HAS_GROUP_LEVEL_PERMISSION = 'HasGroupLevelPermission'

/**
 * Whether the current dashboard session may add complimentary drip credits.
 * Mirrors API authorization for PUT content/campaign/custom/credit (CampaignManage).
 */
export function canAddComplementaryDrip(roles) {
  if (!roles || typeof roles !== 'object') {
    return false
  }
  const campaignManageLevel = roles[CAMPAIGN_MANAGE]
  return [HAS_PERMISSION, HAS_GROUP_LEVEL_PERMISSION].includes(campaignManageLevel)
}
